export default __webpack_public_path__ + "static/Trader-d8acade797edd446b2cd8ef9d03e9e54.png";